import { PageHeader } from '@/components/common/PageHeader';
import { QueryErrorView } from '@/components/common/QueryErrorView';
import {
  OrganizationGrid,
  OrganizationGridSkeleton,
} from '@/features/orgs/components/OrganizationGrid';
import { useGetOrganizationsQuery } from '@/features/orgs/api/orgApi';

/**
 * Organizations list (`/organizations`, design §9). The data source is the same
 * `GET /organizations` the dashboard uses, so both views share one cache entry.
 */
export function OrganizationsPage() {
  const { data, isLoading, isError, error, refetch } = useGetOrganizationsQuery();

  return (
    <section aria-labelledby="organizations-title">
      <PageHeader title="Organizations" description="Organizations you belong to." />

      {isLoading ? (
        <OrganizationGridSkeleton />
      ) : isError ? (
        <QueryErrorView error={error} label="organizations" onRetry={() => void refetch()} />
      ) : (
        <OrganizationGrid organizations={data ?? []} emptyTitle="No organizations yet" />
      )}
    </section>
  );
}
